@if(match?.matchStatus === 'TBP'){
  <div *ngIf="teamName" class="teamfullname" 
      [ngStyle]="{backgroundColor: color}"
      [style.height.px]="rowHeight * 1 - 15"
      [style.font-size.px]="rowHeight / 4">
    <span>{{ teamName }}</span>
  </div>
}

@if(match?.matchStatus === 'TBP' && !selectedTeam && player && match.matchType === 'D'){
  <div class="select-serving-team {{sideNumber === 2 || (isReverse && sideNumber === 1) ? 'second-side': ''}}">
    @if(sideNumber === 1 && !selectedTeam){
      {{'Select Serving Team' | translate}}:
    }  
  </div>
  <div class="select-team" [ngClass]="{'add-border': sideNumber === 1 || (sideNumber === 2 && isReverse)}" (click)="selectTeam(sideNumber)">
    <div class="player-wrap">
      <div *ngIf="player?.player1">
        {{ player?.player1?.name | nameFormatter }}
      </div>
      <div *ngIf="player?.player2">
          {{ player?.player2?.name | nameFormatter }}
      </div>
  </div>
    <ion-checkbox
        slot="end"
        [checked]="selectedTeam === sideNumber"
        (click)="$event.stopPropagation()"
      ></ion-checkbox>
  </div>
}

@if(selectedTeam === sideNumber && match.score?.server?.sideNumber != sideNumber && player && match.matchType === 'D' && hideSelectServingAndServer){
   <div class="select-serving-team">
      {{'Select Server' | translate}}:
  </div>
  <div class="player-selection  {{sideNumber}}" [ngClass]="{'add-border': sideNumber === 1}">
    <div *ngIf="player?.player1"
      class="player-name {{selectedPlayerId === player?.player1?.id ? 'selected-player' : ''}}"
      (click)="selectServer(player?.player1?.id, 1)">

        <ion-thumbnail slot="start">
          <img
            *ngIf="player?.player1?.profile_image; else defaultAvatar"
            [src]="player?.player1?.profile_image"
            alt="Profile Image"
          />
          <ng-template #defaultAvatar>
            <ion-icon class="avatarImage" name="person"></ion-icon>
          </ng-template>
        </ion-thumbnail>
        <div>
          @if(player?.player1?.jerseyNumber){
            <strong>
              #{{player?.player1?.jerseyNumber}}
            </strong>
          }
          <span>
            {{ player?.player1?.name | nameFormatter }}
          </span>
        </div>

        <ion-checkbox
        slot="end"
        [checked]="selectedPlayerId === player?.player1?.id"
        (click)="$event.stopPropagation()"
      ></ion-checkbox>
    </div>
    <div *ngIf="player?.player2"
      class="player-name {{selectedPlayerId === player?.player2?.id ? 'selected-player' : ''}}"
      (click)="selectServer(player?.player2?.id, 2)">

      <ion-thumbnail slot="start">
          <img
            *ngIf="player?.player2?.profile_image; else defaultAvatar2"
            [src]="player?.player2?.profile_image"
            alt="Profile Image"
          />
          <ng-template #defaultAvatar2>
            <ion-icon class="avatarImage" name="person"></ion-icon>
          </ng-template>
        </ion-thumbnail>
        <div>
          @if(player?.player2?.jerseyNumber){
            <strong>
              #{{player?.player2?.jerseyNumber}}
            </strong>
          }          
          <span>
            {{ player?.player2?.name | nameFormatter }}
          </span>
        </div>
        <ion-checkbox
        slot="end"
        [checked]="selectedPlayerId === player?.player2?.id"
        (click)="$event.stopPropagation()"
      ></ion-checkbox>
    </div>
  </div>
}

@if(match.score?.server?.sideNumber === sideNumber){
  <div class="current-server">{{'Server' | translate}}</div>
  <div class="player-selection" [ngClass]="{'add-border': sideNumber === 1}">
    @if(match.score?.server?.playerNumber === 1){
    <div class="player-name">
        <ion-thumbnail slot="start">
          <img
            *ngIf="player?.player1?.profile_image; else defaultAvatar3"
            [src]="player?.player1?.profile_image"
            alt="Profile Image"
          />
          <ng-template #defaultAvatar3>
            <ion-icon class="avatarImage" name="person"></ion-icon>
          </ng-template>
        </ion-thumbnail>
        <div>
          @if(player?.player1?.jerseyNumber){
            <strong>
              #{{player?.player1?.jerseyNumber}}
            </strong>
          }
          <span>
            {{ player?.player1?.name | nameFormatter }}
          </span>
        </div>
    </div>
    }

    @if(match.score?.server?.playerNumber === 2){
    <div class="player-name">
      <ion-thumbnail slot="start">
          <img
            *ngIf="player?.player2?.profile_image; else defaultAvatar4"
            [src]="player?.player2?.profile_image"
            alt="Profile Image"
          />
          <ng-template #defaultAvatar4>
            <ion-icon class="avatarImage" name="person"></ion-icon>
          </ng-template>
        </ion-thumbnail>
        <div>
          @if(player?.player2?.jerseyNumber){
            <strong>
              #{{player?.player2?.jerseyNumber}}
            </strong>
          }
          
          <span>
            {{ player?.player2?.name | nameFormatter }}
          </span>
        </div>
    </div>
    }
  </div>
}

@if(!selectedTeam && match.matchType === 'S' && match?.matchStatus === 'TBP' && player){
   <div class="select-serving-team">
    @if(sideNumber === 1 ){
      {{'Select Server' | translate}}:
    }      
      
  </div>
  <div class="player-selection" [ngClass]="{'add-border': sideNumber === 1 || (sideNumber === 2 && isReverse)}">
    <div *ngIf="player?.player1"
      class="player-name {{selectedPlayerId === player?.player1?.id ? 'selected-player' : ''}}"
      (click)="selectServer(player?.player1?.id, 1);selectTeam(sideNumber)">

        <ion-thumbnail slot="start">
          <img
            *ngIf="player?.player1?.profile_image; else defaultAvatar"
            [src]="player?.player1?.profile_image"
            alt="Profile Image"
          />
          <ng-template #defaultAvatar>
            <ion-icon class="avatarImage" name="person"></ion-icon>
          </ng-template>
        </ion-thumbnail>
        <div>
          @if(player?.player1?.jerseyNumber){
            <strong>
              #{{player?.player1?.jerseyNumber}}
            </strong>
          }
          <span>
            {{ player?.player1?.name | nameFormatter }}
          </span>
        </div>

        <ion-checkbox
        slot="end"
        [checked]="selectedPlayerId === player?.player1?.id"
        (click)="$event.stopPropagation()"
      ></ion-checkbox>
    </div>
    <div *ngIf="player?.player2"
      class="player-name {{selectedPlayerId === player?.player2?.id ? 'selected-player' : ''}}"
      (click)="selectServer(player?.player2?.id, 2)">

      <ion-thumbnail slot="start">
          <img
            *ngIf="player?.player2?.profile_image; else defaultAvatar2"
            [src]="player?.player2?.profile_image"
            alt="Profile Image"
          />
          <ng-template #defaultAvatar2>
            <ion-icon class="avatarImage" name="person"></ion-icon>
          </ng-template>
        </ion-thumbnail>
        <div>
          @if(player?.player2?.jerseyNumber){
            <strong>
              #{{player?.player2?.jerseyNumber}}
            </strong>
          }          
          <span>
            {{ player?.player2?.name | nameFormatter }}
          </span>
        </div>
        <ion-checkbox
        slot="end"
        [checked]="selectedPlayerId === player?.player2?.id"
        (click)="$event.stopPropagation()"
      ></ion-checkbox>
    </div>
  </div>
}

@if(match.matchType === 'S' && selectedTeam === sideNumber && match?.matchStatus === 'TBP'){
  <div class="current-server">{{'Server' | translate}}</div>
  <div class="player-selection" [ngClass]="{'add-border': sideNumber === 1}">
    @if(selectedPlayerInfo?.playerNumber === 1){
    <div class="player-name">
        <ion-thumbnail slot="start">
          <img
            *ngIf="player?.player1?.profile_image; else defaultAvatar3"
            [src]="player?.player1?.profile_image"
            alt="Profile Image"
          />
          <ng-template #defaultAvatar3>
            <ion-icon class="avatarImage" name="person"></ion-icon>
          </ng-template>
        </ion-thumbnail>
        <div>
          @if(player?.player1?.jerseyNumber){
            <strong>
              #{{player?.player1?.jerseyNumber}}
            </strong>
          }
          <span>
            {{ player?.player1?.name | nameFormatter }}
          </span>
        </div>
    </div>
    }

    @if(selectedPlayerInfo?.playerNumber === 2){
    <div class="player-name">
      <ion-thumbnail slot="start">
          <img
            *ngIf="player?.player2?.profile_image; else defaultAvatar4"
            [src]="player?.player2?.profile_image"
            alt="Profile Image"
          />
          <ng-template #defaultAvatar4>
            <ion-icon class="avatarImage" name="person"></ion-icon>
          </ng-template>
        </ion-thumbnail>
        <div>
          @if(player?.player2?.jerseyNumber){
            <strong>
              #{{player?.player2?.jerseyNumber}}
            </strong>
          }
          
          <span>
            {{ player?.player2?.name | nameFormatter }}
          </span>
        </div>
    </div>
    }
  </div>
}
